"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COLLATERAL_DENOMS = exports.MARKET_DENOMS = void 0;
var MARKET_DENOMS;
(function (MARKET_DENOMS) {
    MARKET_DENOMS["UUSD"] = "uusd";
    MARKET_DENOMS["UKRW"] = "ukrw";
})(MARKET_DENOMS = exports.MARKET_DENOMS || (exports.MARKET_DENOMS = {}));
var COLLATERAL_DENOMS;
(function (COLLATERAL_DENOMS) {
    COLLATERAL_DENOMS["UBLUNA"] = "ubluna";
    COLLATERAL_DENOMS["UBETH"] = "ubeth";
})(COLLATERAL_DENOMS = exports.COLLATERAL_DENOMS || (exports.COLLATERAL_DENOMS = {}));
//# sourceMappingURL=provider.js.map